import { Box, Button, Stack } from '@mui/material'
import { type FC, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useRosterSqlSearch } from 'recruiter/hooks'
import { CandidateRosterContextTabs } from 'recruiter/pre-ralph/people/CandidateRosterContextTabs'
import BulkAddToRosters from 'recruiter/pre-ralph/people/CandidateRosters/BulkAddToRosters'
import { type RosterTableRowModel } from 'recruiter/pre-ralph/people/peopleRosterColumns'
import { RosterTableToolbarSlot } from './RosterTableToolbarSlot'

export const PeopleRosterSearchesToolbar: FC = () => {
    const { candidateId } = useParams()
    const { selectedRosterIds, setSelectedRosterIds, data } =
        useRosterSqlSearch()
    const [popoverOpen, setPopoverOpen] = useState(false)
    const buttonRef = useRef<HTMLButtonElement>(null)

    const rows = data as RosterTableRowModel[]
    const hasNotOn = selectedRosterIds.some(
        (id) => !rows.find((r) => r.id === id)?.rosterCandidateId
    )
    const hasAlreadyOn = selectedRosterIds.some(
        (id) => !!rows.find((r) => r.id === id)?.rosterCandidateId
    )
    const buttonLabel =
        hasNotOn && hasAlreadyOn
            ? 'Apply to Searches'
            : hasAlreadyOn
              ? 'Update Searches'
              : 'Add to Searches'

    const handleSuccess = () => {
        setSelectedRosterIds([])
        setPopoverOpen(false)
    }

    const actionsSlot =
        selectedRosterIds.length > 0 ? (
            <>
                <Button
                    ref={buttonRef}
                    variant="text"
                    size="small"
                    onClick={() => setPopoverOpen(true)}
                    sx={{
                        textTransform: 'none',
                        fontSize: '0.75rem',
                        color: 'text.primary',
                        minWidth: 'auto',
                        '&:hover': { bgcolor: 'action.hover' },
                    }}
                >
                    {buttonLabel}
                </Button>
                <BulkAddToRosters
                    isOpen={popoverOpen}
                    onClose={() => setPopoverOpen(false)}
                    onSuccess={handleSuccess}
                    anchorEl={buttonRef.current}
                    candidateId={candidateId ?? ''}
                    selectedRosterIds={selectedRosterIds}
                />
            </>
        ) : null

    return (
        <RosterTableToolbarSlot
            selectedCount={selectedRosterIds.length}
            rightSlot={
                <Stack direction="row" alignItems="center" gap={1}>
                    {actionsSlot}
                    <Box sx={{ ml: 1 }}>
                        <CandidateRosterContextTabs />
                    </Box>
                </Stack>
            }
        />
    )
}
